module.exports = __webpack_public_path__ + "img/video-type.ec9b62f0.svg";